/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Portfolio_Project_6_TitleInputs */

const et_portfolio_project_6_title = /** @type {(inputs: Portfolio_Project_6_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Päringute genereerimine kasvas 20% kõrge konversiooniga AI-keskse lehega.`)
};

const en_portfolio_project_6_title = /** @type {(inputs: Portfolio_Project_6_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Increased lead generation by 20% with a high-converting AI-focused site.`)
};

/**
* | output |
* | --- |
* | "Increased lead generation by 20% with a high-converting AI-focused site." |
*
* @param {Portfolio_Project_6_TitleInputs} inputs
* @param {{ locale?: "et" | "en" }} options
* @returns {LocalizedString}
*/
export const portfolio_project_6_title = /** @type {((inputs?: Portfolio_Project_6_TitleInputs, options?: { locale?: "et" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Portfolio_Project_6_TitleInputs, { locale?: "et" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "et") return et_portfolio_project_6_title(inputs)
	return en_portfolio_project_6_title(inputs)
});